import React from "react";
import styled from "styled-components";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-kq20a9-0"
})(["display:grid;overflow:auto;width:100%;height:100%;grid-template-areas:\"head head head head\" \"main main main main\" \". foot foot .\";grid-template-columns:", " 1fr 1fr ", ";grid-template-rows:min-content min-content auto;", ";"], spacing16, spacing16, mediaBreak600w`
    grid-template-areas:
      "head head head"
      "previous main next"
      ". foot .";

    grid-template-columns: minmax(5.5rem, 1fr) auto minmax(5.5rem, 1fr);
    grid-template-rows: 1fr min-content 1fr;
  `);
const Previous = styled.div.withConfig({
  componentId: "sc-kq20a9-1"
})(["display:none;", ";"], mediaBreak600w`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    grid-area: previous;
    display: flex;
    align-items: center;
    justify-content: start;
  `);
const Main = styled.div.withConfig({
  componentId: "sc-kq20a9-2"
})(["grid-area:main;position:relative;display:flex;justify-content:center;"]);
const Next = styled.div.withConfig({
  componentId: "sc-kq20a9-3"
})(["display:none;", ";"], mediaBreak600w`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    grid-area: next;
    display: flex;
    justify-content: end;
    align-items: center;
  `);
const Foot = styled.div.withConfig({
  componentId: "sc-kq20a9-4"
})(["grid-area:foot;"]);
const Head = styled.div.withConfig({
  componentId: "sc-kq20a9-5"
})(["grid-area:head;"]);

/**
 * Handles layout of slotted items.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.head] - Header, made of grid view and close actions
 * @param {React.ReactNode} [props.main] - Media item to display
 * @param {React.ReactNode} [props.previous] - Previous Navigation
 * @param {React.ReactNode} [props.next] - Next Navigation
 * @param {React.ReactNode} [props.foot] - Footer, made of caption and attribution
 * @param {string} [props.className] - Class
 * @returns {React.ReactNode} - The ItemLayout component.
 */
const ItemLayout = ({
  head,
  main,
  previous,
  next,
  foot,
  className
}) => /*#__PURE__*/_jsxs(Container, {
  className: className,
  children: [head && /*#__PURE__*/_jsx(Head, {
    children: head
  }), previous && /*#__PURE__*/_jsx(Previous, {
    children: previous
  }), /*#__PURE__*/_jsx(Main, {
    children: main
  }), next && /*#__PURE__*/_jsx(Next, {
    children: next
  }), /*#__PURE__*/_jsx(Foot, {
    children: foot
  })]
});
ItemLayout.displayName = "ItemLayout";
export default ItemLayout;